import SearchRepository from 'visuris/Data/Repositories/SearchRepository';
import * as $ from 'jquery';

export interface IGisSearcherSearchOptions {
    term: string;
    time?: Date;
    layers: string[];
}

export default class Searcher {
    private repository: SearchRepository;
    constructor() {
        this.repository = new SearchRepository();
    }

    public search(options: IGisSearcherSearchOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            return this.repository.searchGis(options.term, options.layers, options.time).then((results: any[]) => {
                resolve({
                    results: results
                });
            }).catch((reason) => {
                reject(reason);
            });
        });
        
    }

}